var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sup',[_c('v-icon',{staticStyle:{"color":"#3F9DF5","caret-color":"#3F9DF5","text-shadow":"none"},attrs:{"small":""}},[_vm._v("mdi-check-decagram")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }